(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ic-language-switcher"] && !Shopify.designMode) return;
  try {
    (() => {
    const closeAll = (except) => {
      for (const menu of document.querySelectorAll('[data-ic-lang][open]')) {
        if (menu !== except) menu.removeAttribute('open');
      }
    };

    document.addEventListener('click', (event) => {
      const option = event.target.closest('[data-ic-lang-option]');
      if (option) {
        // Remember an explicit choice so the local-preview Arabic default does not override it.
        try { sessionStorage.setItem('ic-lang-chosen', '1'); } catch (error) { /* storage blocked: ignore */ }
        return;
      }
      closeAll(event.target.closest('[data-ic-lang]'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = document.querySelector('[data-ic-lang][open]');
      if (!open) return;
      open.removeAttribute('open');
      open.querySelector('summary')?.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
